module.exports = __webpack_public_path__ + "img/figure-15.adaa0a79.png";